/** Slugify a heading string for use as an anchor ID. */
function slugify(text) {
  return String(text || "")
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

/**
 * Parse blog HTML and:
 *   1) return a table-of-contents [{ id, text, level }]
 *   2) return a modified HTML string with `id="…"` added to every h2/h3 so anchors work.
 * Works in-browser using DOMParser (no server round-trip required).
 */
export function buildTocFromHtml(html) {
  if (!html || typeof window === "undefined") return { toc: [], html };
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const headings = doc.querySelectorAll("h2, h3");
  const toc = [];
  const usedIds = new Set();
  headings.forEach((h) => {
    const text = h.textContent.trim();
    if (!text) return;
    let base = slugify(text) || "section";
    let id = base;
    let i = 2;
    while (usedIds.has(id)) {
      id = `${base}-${i++}`;
    }
    usedIds.add(id);
    h.setAttribute("id", id);
    toc.push({ id, text, level: h.tagName === "H2" ? 2 : 3 });
  });
  return { toc, html: doc.body.innerHTML };
}
